'use strict';

var errors = require('../../errors.cjs');
var noop = require('../../noop.cjs');
var anticipate = require('../anticipate.cjs');
var back = require('../back.cjs');
var circ = require('../circ.cjs');
var cubicBezier = require('../cubic-bezier.cjs');
var ease = require('../ease.cjs');
var isBezierDefinition = require('./is-bezier-definition.cjs');

const easingLookup = {
    linear: noop.noop,
    easeIn: ease.easeIn,
    easeInOut: ease.easeInOut,
    easeOut: ease.easeOut,
    circIn: circ.circIn,
    circInOut: circ.circInOut,
    circOut: circ.circOut,
    backIn: back.backIn,
    backInOut: back.backInOut,
    backOut: back.backOut,
    anticipate: anticipate.anticipate,
};
const isValidEasing = (easing) => {
    return typeof easing === "string";
};
const easingDefinitionToFunction = (definition) => {
    if (isBezierDefinition.isBezierDefinition(definition)) {
        // If cubic bezier definition, create bezier curve
        errors.invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return cubicBezier.cubicBezier(x1, y1, x2, y2);
    }
    else if (isValidEasing(definition)) {
        // Else lookup from table
        errors.invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return easingLookup[definition];
    }
    return definition;
};

exports.easingDefinitionToFunction = easingDefinitionToFunction;
//# sourceMappingURL=map.cjs.map
